import { dateTextforTimeMS, firstItemWithValueForKey } from './wpn2Model.js';

// #region Related Items: Notes, Images, Associations & People
export function getPersonWithRoleInItem(workItem, role, dbData) {
    if (workItem != undefined) {
        const personnel = workItem.personnel ?? [];
        const index = personnel.findIndex((x) => x.role == role);
        if (index >= 0) {
            return firstItemWithValueForKey('uuid', personnel[index]['person_uuid'], dbData['Person']);
        }
    }
}

export function setRoleForPersonUuidInItem(workItem, role, mgrUuid) {
    if (workItem != undefined && role != undefined  && mgrUuid != undefined) {
        var personnel = workItem['personnel'] ?? [];
        const oldIndex = personnel.findIndex((x) => x.role == role);
        if (oldIndex >= 0) {
            personnel[oldIndex].role = "";
        }
        const newIndex = personnel.findIndex(x => x.person_uuid == mgrUuid)
        if (newIndex >= 0) {
            personnel[newIndex].role = "Manager";
        } else {
            personnel.push({ 'person_uuid': mgrUuid, 'role': "Manager", effort: [] });
        }
        workItem.personnel = [...personnel];
        return workItem;
    }
}

export function personnelDataForWorkItem(workItem, dbData) {
    // Personnel: [ person-effort ]
    // Person-Effort: {"person_uuid": "string?", "role": "string?", "statement": string?, "start": int?, reg_dur: int, ot_dur: string}
    var entries = [];
    if (workItem == undefined) {
        return entries;
    }
    var personnel = workItem['personnel'] ?? [];
    var index;
    for (index = 0; index < personnel.length; index++) {
        const pData = personnel[index];
        const person = firstItemWithValueForKey('uuid', pData['person_uuid'], dbData['Person']);
        const userName = (person != undefined && person.name != undefined) ? person.name : ""
        const regHours = (pData['reg_dur'] ?? 0) / 3600.0;
        const otHours = (pData['ot_dur'] ?? 0) / 3600.0;
        var entry = [
            { key: 'name', title: "Name", value: userName },
            { key: 'work_statement', title: "Statement", value: pData['work_statement'] ?? "" },
            { key: 'start', title: "Started", value: dateTextforTimeMS(pData['start']) },
            { key: 'reg_dur', title: "Reg. Hours", value: regHours.toFixed(2) },
            { key: 'ot_dur', title: "OT Hours", value: otHours.toFixed(2) }
        ];
        entries.push(entry);
    }
    return entries;
}

export function setWorkPersonnelValueForKey(key, value, index, workItem) {
    // Personnel: [ person-effort ]
    // Person-Effort: {"person_uuid": "string?", "role": "string?", "statement": string?, "start": int?, reg_dur: int, ot_dur: string}
    var personnel = workItem.personnel ?? [];
    if (personnel.length > index) {
        personnel[index][key] = value;
        workItem.personnel = [...personnel];
    }
    return workItem;
}

export function workMaterialsData(materials) {
    var entries = [];
    var index;
    for (index = 0; index < materials.length; index++) {
        // {"material_description": "string?", "part_no": "string?", "unit_cost": "double?", "qty": "double?" }
        const unitCost = materials[index].unit_cost ?? 0.0;
        const qty = materials[index].qty ?? 0.0;
        const totalCost = unitCost * qty;
        var entry = [
            { key: 'material_description', title: "Description", value: materials[index].material_description ?? "" },
            { key: 'part_no', title: "Part No.", value: materials[index].part_no ?? "" },
            { key: 'unit_cost', title: "Unit Cost", value: unit_cost?.toFixed(2) ?? "" },
            { key: 'qty', title: "Quantity", value: qty?.toFixed(2) ?? "" },
            { key: 'total_cost', title: "Total Cost", value: totalCost?.toFixed(2) ?? "" }
        ];
        entries.push(entry);
    }
    return entries;
}
